import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComboBase } from '../interfaces/base/base.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TypeContractService {
  private apiUrl = `${environment.apiUrl}/typecontracts`;

  constructor(private http: HttpClient) {}

  comboTypeContract(): Observable<IComboBase[]> {
    return this.http.get<IComboBase[]>(this.apiUrl + '/combo');
  }
}
